import type { Availability } from '../components/BuyTickets/SegmentedTimePicker/Availabilities';

export const parseTimeslotHours = (timeslots: Availability[]) => {
  const hours = timeslots.map((item) => {
    return item.startRaw.hours % 12 === 0 ? 12 : item.startRaw.hours % 12;
  });

  return hours;
};

export const parseTimeslotTime = (timeslots?: Availability[]) => {
  if (!timeslots) return [];

  return timeslots.map((item) => item.timeRaw);
};
